<template>
  <img :src="src || getChannelImage()" alt="Icono" :width="width"/>
</template>

<script>
import { ChannelType } from "@/app/shared/utils/enums";

const channelIcons = {
  [ChannelType.Whatsapp]: "whatsapp.svg",
  [ChannelType.WhatsappVoice]: "whatsapp.svg",
  [ChannelType.Messenger]: "messenger.svg",
  [ChannelType.Inbound]: "inbound.svg",
  [ChannelType.Voice]: "calls.svg",
  [ChannelType.Sms]: "sms.png",
  [ChannelType.VoiceInbound]: "calls.svg",
  [ChannelType.Instagram]: "instagram.svg",
  [ChannelType.BotAI]: "botAi.svg",
};

export default {
  props: {
    type: { required: true, type: Number },
    width: { required: false, type: Number },
    src: String,
    isTTS: { required: false, type: Boolean },
    isApiCalls: { required: false, type: Boolean },
  },
  computed: {
    icon() {
      if (this.isTTS) return "tts.svg";
      if (this.isApiCalls) return "apiCalls.svg";
      return channelIcons[this.type] || "calls.svg";
    },
  },
  methods: {
    getChannelImage() {
      return new URL(`../../assets/channels/${this.icon}`, import.meta.url).href;
    },
  },
};
</script>
